<!-- HorizontalSlider.vue -->
<template>
	<div :class="parentClass">
		<input
			v-model="localScrollValue"
			type="range"
			:min="0"
			:max="scrollMax"
			@input="onSliderInput"
			:class="!id && 'mb-3'"
			class="slider pointer"
			id=""
		/>
	</div>
</template>

<script>
export default {
	props: {
		parentClass: {
			type: String,
			default: "",
		},
		id: String,
		dataList: {
			type: Array,
			default: null,
		},
		scrollContainerRef: {
			// Can be HTMLElement or undefined initially
			default: null,
		},
		scrollContainerId: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			localScrollValue: 0,
			scrollMax: 100,
		};
	},
	mounted() {
		// Wait for next tick to ensure refs are available
		this.$nextTick(() => {
			this.setupScrollListener(this.scrollContainerRef);
			this.calculateScrollMax();
		});
	},
	beforeDestroy() {
		this.removeScrollListener(this.scrollContainerRef);
	},
	methods: {
		setupScrollListener(el) {
			if (el) {
				el.addEventListener("scroll", this.updateSliderOnScroll);
			}
		},
		removeScrollListener(el) {
			if (el) {
				el.removeEventListener("scroll", this.updateSliderOnScroll);
			}
		},
		calculateScrollMax() {
			if (this.scrollContainerRef) {
				const scrollWidth = this.scrollContainerRef.scrollWidth;
				const clientWidth = this.scrollContainerRef.clientWidth;
				this.scrollMax = scrollWidth - clientWidth;
			}
		},
		onSliderInput() {
			if (this.scrollContainerRef) {
				this.scrollContainerRef.scrollLeft = this.localScrollValue;
			}
			this.$emit("input", this.localScrollValue);
		},
		updateSliderOnScroll() {
			if (this.scrollContainerRef) {
				this.localScrollValue = this.scrollContainerRef.scrollLeft;
			}
		},
	},
	watch: {
		dataList: {
			handler() {
				this.$nextTick(() => {
					this.calculateScrollMax();
				});
			},
			deep: true, // Ensures it triggers when dataList updates
		},
		// Recalculate max scroll if scroll container changes
		scrollContainerRef(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.removeScrollListener(oldVal);
				if (newVal) {
					this.$nextTick(() => {
						this.setupScrollListener(newVal);
						this.calculateScrollMax();
						// Sync slider to where this container actually is
						this.localScrollValue = newVal.scrollLeft;
					});
				}
			}
		},
	},
};
</script>

<style scoped>
/* Add custom styles for the slider */
</style>
